import type { RootState, SetState } from '../store';

export type UiTogglesSliceProps = {
    uiToggles: {
        showNewGames: boolean;
        setShowNewGames: (value: boolean) => void;
        hideBottomBar: boolean;
        setHideBottomBar: (value: boolean) => void;
    };
};

export const uiTogglesSlice = ({ set }: SetState<RootState>): UiTogglesSliceProps => ({
    uiToggles: {
        showNewGames: false,
        setShowNewGames: (value) =>
            set(
                (state) => ({
                    ...state,
                    uiToggles: {
                        ...state.uiToggles,
                        showNewGames: value
                    }
                }),
                undefined,
                'uiToggles/setShowNewGames'
            ),
        hideBottomBar: false,
        setHideBottomBar: (value) =>
            set(
                (state) => ({
                    ...state,
                    uiToggles: {
                        ...state.uiToggles,
                        hideBottomBar: value
                    }
                }),
                undefined,
                'uiToggles/setHideBottomBar'
            )
    }
});
